import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js'
var VueScrollTo = require('vue-scrollto')
import VueGtag from "vue-gtag"

Vue.use(VueScrollTo)
Vue.use(VueFullPage)

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "UA-88014128-38" }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
